import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { ManufacturerPriorityFilter } from "../types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.manufacturerState || initialState;

export const selectManufacturersLoading = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.loading
);

export const selectManufacturerPriorityFilter = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.priorityFilter
);

export const selectManufacturersList = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.list
);

export const selectManufacturerPriorityLabelKey = (
  priority: Exclude<ManufacturerPriorityFilter, "ALL">
) => {
  switch (priority) {
    case "HIGH":
      return "MANUFACTURERS.PRIORITY.HIGH";

    case "MEDIUM":
      return "MANUFACTURERS.PRIORITY.MEDIUM";

    case "NORMAL":
      return "MANUFACTURERS.PRIORITY.NORMAL";

    default:
      return "MANUFACTURERS.PRIORITY.NORMAL";
  }
};
